import { render, staticRenderFns } from "./PurchaseDetailsModal.vue?vue&type=template&id=11da7ec8&scoped=true"
import script from "./PurchaseDetailsModal.vue?vue&type=script&lang=js"
export * from "./PurchaseDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDetailsModal.vue?vue&type=style&index=0&id=11da7ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11da7ec8",
  null
  
)

export default component.exports